import {skipToken} from '@reduxjs/toolkit/query';
import {Box, HStack, Link, Show, Stack, Text} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {useGetUserQuery} from '@dms/api/customer';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {getNaturalPersonFullName} from '../../utils/getNaturalPersonFullName';

interface OlderReportRowProps extends TestIdProps {
  href: string | Nullish;
  title: string;
  index: number;
  isDisabled?: boolean;
  createdBy?: string | Nullish;
  meta?: ReactNode;
}

export function OlderReportRow(props: OlderReportRowProps) {
  const {data: user} = useGetUserQuery(
    isNotNilOrEmpty(props.createdBy) && typeof props.createdBy === 'string'
      ? {id: props.createdBy}
      : skipToken
  );

  const userFullName = getNaturalPersonFullName(user);
  const isOdd = props.index % 2 === 0;

  return (
    <Box
      backgroundColor={isOdd ? 'palettes.neutral.20.100' : 'general.white'}
      padding={3}
      data-testid={suffixTestId('olderReportRow', props)}
    >
      <Stack
        direction={['column', 'row']}
        justify={['flex-start', 'space-between']}
        align={['flex-start', 'center']}
        spacing={1}
      >
        <Link
          data-testid={suffixTestId('reportLink', props)}
          href={props.href ?? undefined}
          title={props.title}
          isDisabled={props.isDisabled}
          rightIcon="action/open_in_new"
          size="small"
          target="_blank"
        />
        <HStack spacing={1} align="center">
          <Show when={isNotNilOrEmpty(userFullName)}>
            <Text size="small" color="primary">
              {userFullName}
            </Text>
          </Show>
          {props.meta}
        </HStack>
      </Stack>
    </Box>
  );
}
